var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowUturnUpIcon, EllipsisHorizontalIcon, EyeIcon, TrashIcon, } from "@heroicons/react/24/outline";
import { useContext } from "@wordpress/element";
import { REMOVE_ARCHIVED_TASK } from "../../../constants";
import { useTaskActions } from "../../../hooks/actions/useTaskActions";
import { AppContext } from "../../../providers/AppContextProvider";
import { ArchiveContext } from "../../../providers/ArchiveContextProvider";
import { WPQTDropdown, WPQTDropdownIcon, WPQTDropdownItem, } from "../WPQTDropdown";
function ArchivedTaskDropdown({ task }) {
    const { state: { isUserAllowedToDelete }, } = useContext(AppContext);
    const { archiveDispatch } = useContext(ArchiveContext);
    const { deleteTask, restoreArchivedTask } = useTaskActions();
    const pipelineExists = task.pipeline_name !== null;
    return (_jsxs(WPQTDropdown, { menuBtn: ({ active }) => (_jsx(WPQTDropdownIcon, { isActive: active, IconComponent: EllipsisHorizontalIcon })), children: [_jsx(WPQTDropdownItem, { text: "View task", icon: _jsx(EyeIcon, { className: "wpqt-icon-blue wpqt-size-4" }) }), _jsx(WPQTDropdownItem, { text: "Restore task", icon: _jsx(ArrowUturnUpIcon, { className: "wpqt-icon-green wpqt-size-4" }), disabled: !pipelineExists, id: `restore-task-${task.id}-dropdown-item`, tooltipText: "Task cannot be restored because the board has been deleted.", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    e.stopPropagation();
                    yield restoreArchivedTask(task.id, () => {
                        archiveDispatch({
                            type: REMOVE_ARCHIVED_TASK,
                            payload: task.id,
                        });
                    });
                }) }), isUserAllowedToDelete && (_jsx(WPQTDropdownItem, { text: "Delete", icon: _jsx(TrashIcon, { className: "wpqt-icon-red wpqt-size-4" }), onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    e.stopPropagation();
                    yield deleteTask(task.id, () => {
                        archiveDispatch({
                            type: REMOVE_ARCHIVED_TASK,
                            payload: task.id,
                        });
                    });
                }), className: "!wpqt-mb-0" }))] }));
}
export { ArchivedTaskDropdown };
